module.exports = __webpack_public_path__ + "static/media/b.2413df84.jpg";